<template>
    <div class="das">
        <div class="d-flex align-items-center">
            <div class="icon icon-mon-reseau pe-1 ps-2 ps-md-0 text-gray4" aria-hidden="true" />
            <div class="ps-3 ps-md-0">
                <template v-if="head">
                    <a :href="'#modal-das'" data-bs-toggle="modal"><strong v-html="prefix" /></a>
                    <strong v-html="' ' + head" /><br>
                </template>

                <template v-if="trunk">
                    <a :href="'#modal-das'" data-bs-toggle="modal"><strong v-html="prefix" /></a>
                    <strong v-html="' ' + trunk" /><br>
                </template>

                <template v-if="member">
                    <a :href="'#modal-das'" data-bs-toggle="modal"><strong v-html="prefix" /></a>
                    <strong v-html="' ' + member" /><br>
                </template>
            </div>
        </div>

        <ob1-popin-modal-visual
            :id="'modal-das'"
            :aria-labelledby="'modal-label-das'"
            additional-classes="d-webview-none d-md-block"
        >
            <template #visual>
                <div :class="['ob1-modal-img d-webview-none', isSoshShop ? 'bg-primary3' : 'bg-black']">
                    <div class="image-crop">
                        <div class="icon icon-mon-reseau text-white" aria-hidden="true" />
                    </div>
                </div>
            </template>
            <template #content>
                <p :id="'modal-label-das'" class="h4" v-html="popinTitle" />
                <p v-html="popinText" />
            </template>
        </ob1-popin-modal-visual>
    </div>
</template>

<script>
export default {
    name: "Das",
    props: {
        head: {
            type: String,
            default: null
        },
        trunk: {
            type: String,
            default: null
        },
        member: {
            type: String,
            default: null
        },
        prefix: {
            type: String,
            required: true
        },
        popinTitle: {
            type: String,
            required: true
        },
        popinText: {
            type: String,
            required: true
        },
        isSoshShop: {
            type: Boolean,
            default: false,
            required: false
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.icon {
    font-size: px-to-rem(55);
}

.image-crop {
    position: relative;
    width: px-to-rem(170);
    height: px-to-rem(180);
    top: 16%;
    left: 34%;
    @media (min-width: 736px) {
        top: 12%;
        left: 8%;
    }
}

.image-crop .icon {
    position: absolute;
    font-size: px-to-rem(114);
}

@media (min-width: 736px) {
    .image-crop .icon {
        font-size: px-to-rem(149);
    }
}

</style>
